const partTypeStrings = {
    FRONT_WIPER: "FRONT WIPER",
    REAR_WIPER: "REAR WIPER",
    RAIN_DEFENSE: "RAIN DEFENSE",
    ADAS_RECALIBRATION: "ADAS RECALIBRATION",
    RECALIBRATION: "RECALIBRATION",
    REPLACE_FEE: "REPLACE FEE",
    RECYCLE_FEE: "RECYCLE FEE",
    MOBILE_FEE: "MOBILE FEE",
    REPAIR_FEE: "REPAIR FEE",
    EARLY_BIRD: "EARLY BIRD",
    SERVICE_PACKAGE_DISCOUNT: "SERVICE PACKAGE DISCOUNT",
    DONATION: "DONATION",
};

export { partTypeStrings };
